import '@pisaka/ui/dist/index.css';
import { LandingPage } from '../../modules/landing/LandingPage';

export default LandingPage;
